<template>
  <div class="login_container">
    <div class="login_box">
      <el-form class="login_form" label-width="60px" :model="from" :rules="login_rules" ref="jianyiRef">
        <div class="header"><span style="">申请试用！</span></div>
        <el-form-item prop="info" label-width="0px">
          <el-input
            rows="5"
            type="textarea"
            placeholder="申请试用详细信息！"
            resize="none"
            v-model="from.info"
            maxlength="200"
            show-word-limit
          >
          </el-input>
        </el-form-item>
        <div style="margin-top: 22px;margin-bottom: 12px">
          <span style="width: 312px;
          height: 18px;
          font-size: 18px;
          font-family: Noto Sans S Chinese;
          font-weight: 400;
          color: #333333;
          ">请留下有效的联系方式，以便与您联系。</span>
        </div>
        <el-form-item prop="realname" label="姓名:" label-width="60px" style="margin-bottom: 22px">
          <el-input placeholder="请输入姓名" v-model="from.realname" style="width: 502px;"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="电话:" label-width="60px" style="margin-bottom: 22px">
          <el-input placeholder="请输入电话"  v-model="from.phone"  style="width: 502px;"
          ></el-input>
        </el-form-item>
        <el-form-item prop="unit" label="单位:" label-width="60px" style="margin-bottom: 22px">
          <el-input placeholder="请输入单位" v-model="from.unit"  style="width: 502px;"
          ></el-input>
        </el-form-item>
        <el-form-item class="verification-item" prop="code" label="" label-width="60px" style="margin-bottom: 22px;width: 555px">
          <el-input placeholder="请输入验证码" type="email" v-model="from.code" style="width: 350px"
          ></el-input>
          <img style="float: right;width: 133.5px;height: 40px;" :src="qrcodeUrl" alt="验证码加载失败..."
               data-track-text="刷新图形验证码"
               aria-label="刷新图形验证码"
               @click="getValicode"/>
        </el-form-item>
        <el-form-item class="login_button">
          <el-button type="primary" data-track-text="提交试用申请" aria-label="提交试用申请" @click="submitJianyiFrom()"><span style="width: 79px;
          height: 19px;
          font-size: 20px;
          font-family: Noto Sans S Chinese;
          font-weight: 400;
          color: #FFFFFF;
          ">提交申请</span></el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {tryOutRequest, authServiceClient, valicodeRequest} from '../tools/api/auth-api'

  export default {
    name: "TryOut",
    data() {
      let checkPhone = (rule, value, callback) => {
          if (!value) {
            return callback(new Error('请输入您的手机号'));
          }
          let regs = /^[1][3,4,5,7,8][0-9]{9}$/;
          if(!regs.test(value)){
            return callback([new Error('请输入合法的手机号')]);
          }else{
            return callback();
          }
        }
      return {
        qrcodeUrl: "data:image/gif;base64,/9j/4AAQSkZJRgABAgAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAeAJYDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD0R7m7e8NtHbGJdpYTyjcpwcHAX6jqVPPAODVeZk02Q3Fxc3E8znbFCHPzdvujAJ59MdO/Jt3k8ltB+4iMsjE4yeF4JyT6cf8A6hkjNXTbaeJpL2XzLxx96XcqqfQAEZAPv+VbKz3Nk1fcsWSSO/8AaN9OFfadkYkGyNfwODkc5qxJcIz/AOi3UTTf88t4bfjqAM8HHf8AOsOzt9KaS5eeEhPPEUajc2BwO3ueT0HXgVpHS7eGQ3VlbxMzKB8w3KMZIIH48kc9PQYpi6FiUTurraSeTO7hpPNJbaMYyoPHYcDjqepNZc+lRxapZCSaeaSdss7PgjYCeMcjOR3/AIRj31IpIp8wiHyXHzZCgjcSS2PfqTkDOfrVe5lD6tpb5GAZBnPByvBHsaE7he5bFo8YzBPIjekjtKp9M7jn8iPxpI7/ACpMkLbQxUvB+9XcDgj5fmyCCDkDBBFWJCqFZG3nGEAUMfvEDkD8Oewz0GafkZxkZPOKLFFc30IAOy45GeLaT/4mk+1yScW9tK3+1KPLUH3z835KR+uHgtOLeaMqEzvIkiIbaVPAyQVbJHUdMjHORIJVMpjw+4Z5KHHbvjHcfr6HCSfUNTG0uCSe4vxMzoguCdsUpX5j15AB9O+D6DFN8m5v7gaebrzbO3ULLIVw0jgnAJzycbc4A5B9QAx55V1a+tbZc3EzpsYjiMbeW/I/rWza2y2cUcESjywp3MT8xbjnHfPPf0/CtgRGq3UEUKtPDI4AXbs2BzjJwMnHQ8elQzazbRRbgxLgsDGFJ3FTtKhhxnd/I8cHF2eV4rdnSPc+DhWOBnHGSAcD3AP0rG1XymNkEdV/fRs8RcfIGzgnB4HDdOOD6UkK/UsbNYlxJ9oihcjcIPL3Ljjgt681MoNxKkplkJKFC8Mw8qORW2kYzksSSMEEfJg4PVrTzorW5Ox8YSTPT8xz9cEd8HpSxX7vqxhcGKNbbzGR8ZVs9yCR096V73EpLW49JryFvLkRJyO6sEdh6hTwfc5H09Wwa1aXEMUqC42yorpm2k5DDIwcYP4Z/UVcPlzplXBAJG5D0IOD+uRUDvKh2TojwlsF+mFx365OfoMH25B6oX+0If7lz/4DSf8AxNFKsTxSGSJjKrKBhpDgAZxjt3PPXpycDBTC5HLblpRD58yKSJUKBiwKyBmBc5G1sqNvHG7HH3bBjZyjMxUqxyq4IYYIAORx1zxzx1I6y1zkXiGa+1AW9hGoLrhPtHTIySeORxkYyex45ym0rCk7O7NKwtGggjguIkeRvMZ3wTk7h3x3B7kHjp1xDazWajZb38Ql3lQplDBuflHbPGBkfmepf/YqXB3ahcz3ZPJQtsjB7EKOhx7+tWv7MsP+fG2/79L/AIUXYNX7FWO7tr5jC0kRn5w0bhwRn1H8j/8AXqKSzD3EAn2rPFLvjlb5mYZJ25Jzg8fy7Crx0uwIwLOFfdECn8xzVG9s7mzgkltp99uilmgmJOABztYcjgYA6UJtCs+pqIySSBiJFkUFdvOOeee3br+Heo5EXzyzF0LAKriQ44z/AA9AeT254z0FYllf/wBqKIjG2/DCJmkIKnaQfmHI4OMjkVsKjXEVuzNH5pjIeTyuSCOduSdvzbTzu6Y560X6j5rxEtpJo3IuwqO6qTtLMgfGCAx7cDjA7n+Kpy1wsuCiOhPBHBA/HqaY8BQFo9pABG2QZAHseo6dKjh/eIPJdguAdsg3Ac8e/UUK/UNdh4aOOVpjasjtw0gQEke5HPp/kUksnmFTBOjOH3BWfA+6RjgcjPr657AVSutZax3q9uryj5ztbaCDnHY84A/+tQlrdatCk9zcmCCRQ6RW3BweRuYjng4I6cCi/QV7lqbUPJdIm8hZCQT5ku0bM8sOCemcA4BPGR1rPvjpckbRpJbusjFyBMmEY4G4ZPynknjrhs8nnTj0uxiAAtYiQc5ddx/M808WFmA4FpAA4w2Ix8wznnjnkA/hRqNJ9TGhN6YTGlnDcMVwtykgUsM5GfXk5PPU/jUkMT2Upa5kj+0SMv7wnAUdAFHHHbGfwPSrh0a3RxJatJbOCWHlt8uf908Y9hisvUtVn0+dLa8jSVsArMhI+Qtgnb03/KcHtn65G7E8qWmxuwMXhxG6h92WLEuDlsnHPTqB6enGKmRw6kgNjJHzKR0OO/8Ak1hvqCWenyXzBzHFEZycbn2kZGMnr6jOPStmOVpImKqC65XBOASPz4oW12UpLqIbcAkxs0ZPXbjB/A0VNRTHY//Z",
        timer:'',
        from: {
          info: '',
          realname: "",
          code: "",
          phone:"",
          unit:""
        },
        login_rules: {
          code:[
            {required: true, message: '请输入验证码', trigger: 'blur'},
            {min: 4, max: 4, message: '请输入4位验证码', trigger: 'blur'}
          ],
          unit:[
            {required: true, message: '请输入您的机构', trigger: 'blur'}
          ],
          realname: [
            {required: true, message: '请输入您的姓名', trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入您的手机号', trigger: 'blur'},
            { validator: checkPhone, trigger: 'blur' }
          ],
          info: [
            {required: true, message: '请输入您的详细信息', trigger: 'blur'}
          ]
        },
      }
    },
    mounted() {
      this.getValicode();
    },
    beforeDestroy() {
      clearTimeout(this.timer);
    },
    methods: {
      getValicode() {
        const CODE_KEY = 'code';
        let metadata;
        if (localStorage.getItem(CODE_KEY)) {
          metadata = {[CODE_KEY]: localStorage.getItem(CODE_KEY)}
        } else {
          metadata = {}
        }
        authServiceClient.getValicode(valicodeRequest, metadata).then(res => {
          this.qrcodeUrl = 'data:image/gif;base64,' + res.toObject().valicodeImage;
        })
      },
      submitJianyiFrom() {
        const that = this;
        this.$refs.jianyiRef.validate((valid) => {
          if (!valid) {
            return false;
          }
          let request = tryOutRequest;
          request.setUnit(that.from.unit);
          request.setCode(that.from.code);
          request.setPhone(that.from.phone);
          request.setRealName(that.from.realname);
          request.setInfo(that.from.info);
          const TOKEN_KEY = 'token';
          const CODE_KEY = 'code';
          const metadata = {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            [CODE_KEY]: localStorage.getItem(CODE_KEY)
          };
          authServiceClient.tryOut(request, metadata).then(res => {
            if (res.getStatus()) {
              that.$message({
                center: true,
                type: 'success',
                showClose: true,
                duration: 3000,
                message: res.getMessage()
              });
              this.timer = setTimeout(()=>{
                window.parent.postMessage({
                  data: "close"
                }, '*');
              }, 3000);
              return;
            }
            that.$message({
              center: true,
              type: 'error',
              showClose: true,
              duration: 3000,
              message: res.getMessage()
            });
            that.getValicode();
          }).catch(err => {
            that.$message({
              center: true,
              type: 'error',
              showClose: true,
              duration: 3000,
              message: '提交意见失败，请稍后再试!'
            });
            window.parent.postMessage({
              data: "close"
            }, '*');
          })
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .el-textarea__inner {
    overflow-y: hidden;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    height: 140px;
  }

  /deep/ .el-textarea .el-input__count {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }

  /deep/ .el-input__inner {
    height: 44px !important;
    font-size: 16px;
    box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
  }

  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #fbafaf !important;
  }

  /deep/ .el-form-item__error {
    font-size: 14px;
    color: rgba(223, 37, 37, 1);
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  .login_container {
    height: 0;
    width: 0;
    background-color: #feffff;
  }

  .login_box {
    width: 100%;
    height: 100%;
    background-color: white;
    border-radius: 3px;
    position: absolute;
    box-shadow: 0 0 10px #dddddd;

    .login_button {
      font-family: Noto Sans S Chinese !important;
      text-align: center;

      .el-button {
        width: 425px;
        height: 48px;
        background: #184482;
        border-radius: 3px;
      }
    }

    .login_form {
      .header {
        font-size: 22px;
        font-family: Noto Sans S Chinese;
        font-weight: 400;
        color: #333333;
        padding-bottom: 22px;
        text-align: center;
      }

      position: absolute;
      padding-top: 25px;
      width: 867px;
      left: 50%;
      transform: translate(-50%, 0px);
      box-sizing: border-box;
    }
  }

  @media (max-width: 768px) {
    .login_container {
      width: 100%;
      min-height: 100vh;
      height: auto;
      background: #fff;
    }

    .login_box {
      position: static;
      width: 100%;
      min-height: 100vh;
      height: auto;
      padding: 18px 16px 28px;
      box-shadow: none;
      box-sizing: border-box;
    }

    .login_box .login_form {
      position: static;
      width: 100%;
      padding: 0;
      transform: none;
    }

    .login_box .login_form .header {
      padding-bottom: 16px;
      font-size: 19px;
    }

    .login_form /deep/ .el-form-item,
    .login_form /deep/ .el-input,
    .login_form /deep/ .el-textarea {
      width: 100% !important;
      box-sizing: border-box;
    }

    .login_form /deep/ .el-form-item {
      margin-bottom: 14px !important;
    }

    .login_form /deep/ .verification-item .el-form-item__content {
      display: flex;
      gap: 10px;
      margin-left: 0 !important;
    }

    .login_form /deep/ .verification-item .el-input {
      flex: 1 1 auto;
      width: auto !important;
      min-width: 0;
    }

    .login_form /deep/ .verification-item img {
      flex: 0 0 104px;
      width: 104px !important;
      height: 40px;
      float: none !important;
      object-fit: cover;
    }

    .login_box .login_button .el-button {
      width: 100%;
      height: 44px;
    }
  }
</style>
